export const DATA_LAYERS = [
  { value: "management", label: "Управленческие данные" },
  { value: "corrections", label: "Корректировки" },
  { value: "source", label: "Исходные данные" },
];

export const DEFAULT_DATA_LAYER = DATA_LAYERS[0].value;

export const getDataLayerLabel = (value) =>
  (DATA_LAYERS.find((layer) => layer.value === value) || DATA_LAYERS[0]).label;
